import { cn } from "@src/utils";
import { ChevronDown } from "lucide-react";
import * as React from "react";

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
	error?: boolean;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
	({ className, error, children, ...props }, ref) => (
		<div className="relative">
			<select
				className={cn(
					"flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 appearance-none",
					error && "border-red-500",
					className,
				)}
				ref={ref}
				{...props}
			>
				{children}
			</select>
			<ChevronDown className="absolute right-3 top-3 h-4 w-4 opacity-50 pointer-events-none" />
		</div>
	),
);
Select.displayName = "Select";

export { Select };
